<template>
    <Page withNavbar withNavigation>
        <main>
            <SectionTitle
                :title="config.CONTRACT_TITLE"
                :description="config.CONTRACT_DESCRIPTION"
            />
            <SectionPicture>
                <ArtContract :color="config.COLOR_PRIMARY"/>
            </SectionPicture>
            <section class="checkbox">
                <Checkbox v-model="signed">
                    <div class="legal-container">
                        <!-- WARN potentially dangerous in case of misconfig, intentional or not -->
                        <small v-html="config.CONTRACT_RIGHTS"/>
                        <small>{{ config.CONTRACT_LEGAL_TEXT }}</small>
                        <small>
                            {{ config.CONTRACT_LEGAL_PP_TEXT }}
                            <a :href="legalUrl" target="_blank" rel="noreferrer">{{ config.CONTRACT_LEGAL_PP_LINK }}</a>
                        </small>
                    </div>
                </Checkbox>
            </section>
            <SectionActions>
                <Button :color="config.COLOR_PRIMARY" :to="{ name: next }" :disabled="!signed">
                    {{ config.CONTRACT_CTA }}
                </Button>
            </SectionActions>
        </main>
    </page>
</template>
<script>
import { SolutionConsumer } from '../../mixins';
import { Page } from '../../components/mobile';
import { SectionTitle, SectionPicture, SectionActions } from '../../components/shared';

export default {
    name: 'Contract',
    components: {
        Page, SectionTitle, SectionPicture, SectionActions,
    },
    mixins: [SolutionConsumer],
    props: {
        next: {
            type: String,
            default: 'deposit.upload',
        },
    },
    data () {
        return {
            signed: false,
        };
    },
    computed: {
        legalUrl () {
            const url = this.config.CONTRACT_LEGAL_PP_LINK_URL;
            return url ? `${url}${url.endsWith('/') ? '' : '/'}${this.language}` : '';
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

main {
    @include container(40px);
    align-content: center;
    flex-grow: 1;
}

.legal-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
}
</style>
